<template>
    <el-dialog title="站点收煤详情" style="text-align:center" :visible="visible" :show="show" width="75%"  @close="close" :close-on-click-modal="false">
        <el-table :data="dataList"  border  style="width: 100%" height="500px">
            <el-table-column type="index" label="序号"></el-table-column>
            <el-table-column label="主力煤源（名称/热值/硫分）"  align="center">
                <template slot-scope="scope">
                    {{scope.row.cocalName}}/{{scope.row.cocalHots}}/{{scope.row.cocalLiufen}}
                </template>
            </el-table-column>
            <el-table-column prop="cocalWeight" label="主力煤占比" width="200"></el-table-column>
            <el-table-column label="辅助煤源（热值/硫分）" >
                <template slot-scope="scope">
                    {{scope.row.aidedCocalHots}}/{{scope.row.aidedCocalLiufen}}
                </template>
            </el-table-column>
            <el-table-column prop="aidedCocalWeight" label="辅助煤占比" width="200"></el-table-column>
            <el-table-column prop="aidedCocalPrice" label="辅助煤源单价" width="200"></el-table-column>
            <el-table-column prop="aidedCocalConst" label="所需库存（吨）" width="200"></el-table-column>

        </el-table>
        <div style="display: flex;flex-wrap: wrap;width: 100%;justify-content: center;">
            <el-button class="btn close" @click="close()">取消</el-button>
        </div>
    </el-dialog>
</template>
<script>
    export default {
        name:'stationCocalMessageList',
        data() {
            return{
                visible:false,
                dataList:[],
                ruleForm:{}
            }
        },
        props:{
            show:{
                type:Boolean,
                default:false
            },
            rowData:{
                type:Object,
                default:{}
            }
        },
        watch:{
            show(){
                this.visible = this.show
            },
            rowData(){
                this.loadCocalMessageList();
            }
        },
        methods:{
            loadCocalMessageList(){
                if (this.rowData.id) {
                    this.$http({
                        url: "stationMessage/info/"+this.rowData.id,
                        method: "get",
                    }).then(({data}) => {
                        if (data.data!=null){
                            this.ruleForm = data.data;
                            this.dataList = data.detailList;
                        }
                    });
                }
            },
            close(){
                this.$emit("sendToParent",false);
                this.dataList = [];
                this.ruleForm = {};
            }
        }
    }
</script>